import { Node_Type } from '@wix/ricos/schema';
import React from 'react';
export const htmlAttributesPlugin = ()=>({
        config: {},
        type: '',
        nodeViewDecorators: [
            htmlAttributesDecorator
        ],
        nodeViewRenderers: {
            [Node_Type.EXTERNAL]: (_node)=>/*#__PURE__*/ React.createElement(React.Fragment, null)
        }
    });
const htmlAttributesDecorator = {
    rule: (node)=>node.type === Node_Type.EXTERNAL,
    decorate: ({ node })=>{
        const n = node;
        if (n.type !== Node_Type.EXTERNAL) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
        const textData = n.textData;
        if (textData?.text == null) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
        const externalData = n.externalData;
        const props = Object.fromEntries(Object.entries(externalData?.fields ?? []).map(([k, v])=>[
                k,
                v.stringValue
            ]));
        return /*#__PURE__*/ React.createElement("span", props, textData.text);
    }
};

//# sourceMappingURL=ricos-html-attributes-plugin.js.map